import { render, staticRenderFns } from "./TButtonGroup.vue?vue&type=template&id=a029fe38&scoped=true&"
import script from "./TButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./TButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./TButtonGroup.vue?vue&type=style&index=0&id=a029fe38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a029fe38",
  null
  
)

export default component.exports